module.exports = __webpack_public_path__ + "img/ok.b7c8f272.svg";